import { useEffect, useState } from 'react';
import { getSyncProgress } from '../utils';

const TICK_MS = 500;

const useSyncProgress = ({ active, messageCount }) => {
  const [elapsedMs, setElapsedMs] = useState(0);

  useEffect(() => {
    if (!active) return undefined;

    const startedAt = Date.now();
    const timerId = setInterval(() => {
      setElapsedMs(Date.now() - startedAt);
    }, TICK_MS);

    return () => clearInterval(timerId);
  }, [active]);

  return getSyncProgress(elapsedMs, messageCount);
};

export default useSyncProgress;
